export enum SNCDashboardMetricDateRange {
    TodayDescription = 'Today',
    Today = 1,
    YesterdayDescription = 'Yesterday',
    Yesterday = 2,
    Last7DaysDescription = 'Last 7 Days',
    Last7Days = 3,
    Last30DaysDescription = 'Last 30 Days',
    Last30Days = 4,
}
